import {FillObjectStrategy} from "../../../../_types/FillObjectStrategy";
import {Point} from "../../../../_types/Point";
import {Size} from "../../../../_types/Size";

export class FrameFillObjectStrategy implements FillObjectStrategy {
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    getPosition(index: number, sceneSize: Size): Point {
        return {
            x: sceneSize.width / 2,
            y: sceneSize.height / 2
        };
    }

}